/* APPEX Home — comportamiento global (una sola inicialización) */
(function(){
if(window.__appexInit) return; window.__appexInit = 1;
document.documentElement.classList.add('js');

function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }

/* Toast */
var tT;
window.showToast = function(msg){var t=document.getElementById('toast');if(!t)return;document.getElementById('toastMsg').textContent=msg;t.classList.add('show');clearTimeout(tT);tT=setTimeout(function(){t.classList.remove('show');},2200);};

/* Desktop detection */
window.isDesktopWeb = function(){return matchMedia('(min-width:641px)').matches && !matchMedia('(max-device-width:812px)').matches;};

/* QR modal */
window.qrOpen = function(){var m=document.getElementById('qrModal');if(m)m.classList.add('open');};
window.qrClose = function(){var m=document.getElementById('qrModal');if(m)m.classList.remove('open');};
document.addEventListener('keydown',function(e){if(e.key==='Escape')window.qrClose();});

/* Compra: si el botón lleva data-url navega; si lleva data-variant añade al carrito; si no, toast */
window.buy = function(m, el){
  if(m==='SCAN' && window.isDesktopWeb()){ window.qrOpen(); return; }
  var d = el && el.dataset ? el.dataset : {};
  if(d.variant){
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(d.variant,10),quantity:1})})
      .then(function(r){if(!r.ok)throw 0;showToast(m+' añadida a la cesta');document.dispatchEvent(new CustomEvent('appex:cart:added'));})
      .catch(function(){showToast('No se pudo añadir. Inténtalo de nuevo.');});
    return;
  }
  if(d.url){ window.location.href = d.url; return; }
  showToast(m+' añadida a la cesta');
};
window.startScan = function(){if(window.isDesktopWeb()){window.qrOpen();}else{var s=document.getElementById('scan');if(s){s.scrollIntoView({behavior:'smooth'});}else{showToast('Abriendo APPEX SCAN…');}}};

/* Drawer */
window.drawerOpen = function(v){document.body.classList.toggle('dwOpen',v);};

/* Reveal on scroll */
ready(function(){
  setTimeout(function(){var r=document.querySelectorAll('.reveal');for(var i=0;i<r.length;i++)r[i].classList.add('in');},2500);
  var rio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');rio.unobserve(e.target);}});},{threshold:0.1});
  document.querySelectorAll('.reveal').forEach(function(el){rio.observe(el);});
});

/* Miembro: precios rebajados persistentes */
(function(){try{if(localStorage.getItem('appex_member'))document.body.classList.add('member');}catch(e){}})();

/* Promo popup */
window.closePromo = function(){var p=document.getElementById('promo');if(p)p.classList.remove('show');};
window.promoChannel='email';
window.promoMode = function(mode){window.promoChannel=mode;var i=document.getElementById('pInput'),s=document.getElementById('pPrefix');
  document.getElementById('ptabEmail').classList.toggle('active',mode==='email');
  document.getElementById('ptabTel').classList.toggle('active',mode==='tel');
  if(mode==='email'){i.type='email';i.placeholder='Tu correo electrónico';i.autocomplete='email';s.style.display='none';}
  else{i.type='tel';i.placeholder='Tu número de móvil';i.autocomplete='tel';s.style.display='block';}
  i.value='';i.focus();document.getElementById('promoField').classList.remove('err');};
window.promoSubmit = function(){var f=document.getElementById('promoField'),i=document.getElementById('pInput'),v=i.value.trim();
  var ok = window.promoChannel==='email' ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) : v.replace(/\D/g,'').length>=6;
  if(!ok){f.classList.remove('err');void f.offsetWidth;f.classList.add('err');i.focus();return;}
  try{localStorage.setItem('appex_member','1');}catch(e){}
  document.body.classList.add('member');window.closePromo();
  setTimeout(function(){showToast('¡Descuento activado! Precios rebajados ✓');},400);};
window.promoLogin = function(){
  var b=document.querySelector('.promo-get'); if(b) b.textContent='Acceder';
  var i=document.getElementById('pInput'); if(i){i.value='';i.placeholder=(window.promoChannel==='tel')?'Tu número de miembro':'Tu correo de miembro';i.focus();}
  showToast('Introduce tus datos y recuperamos tus precios de miembro');};
ready(function(){
  var promoShown=false;
  addEventListener('scroll',function(){
    if(promoShown)return;
    var sc=document.getElementById('scan'); var p=document.getElementById('promo'); if(!sc||!p)return;
    var r=sc.getBoundingClientRect();
    if(r.top + r.height/2 <= innerHeight*0.9){p.classList.add('show');promoShown=true;}
  },{passive:true});
});

/* Slider de reseñas */
window.slideQ = function(d){var g=document.getElementById('qrow');if(!g)return;var c=g.querySelector('.quoteE');var w=c.getBoundingClientRect().width+(matchMedia('(max-width:940px)').matches?40:56);g.scrollBy({left:d*w,behavior:'smooth'});};

/* Newsletter footer */
window.newsChannel='email';
window.newsMode = function(mode){window.newsChannel=mode;var i=document.getElementById('newsInput');
  document.getElementById('tabEmail').classList.toggle('active',mode==='email');
  document.getElementById('tabSms').classList.toggle('active',mode==='sms');
  if(mode==='email'){i.type='email';i.placeholder='Correo electrónico';i.autocomplete='email';}
  else{i.type='tel';i.placeholder='Número de móvil';i.autocomplete='tel';}i.value='';i.focus();};

/* Chat FAB adaptativo */
ready(function(){
  var fab=document.getElementById('chatFab'); if(!fab)return;
  var sel='.hero,.hero-bar,.method,.results,.final,.appex-foot';
  function upd(){var els=document.querySelectorAll(sel);var x=window.innerWidth-53,y=window.innerHeight-53,dark=false;
    els.forEach(function(el){var r=el.getBoundingClientRect();if(y>=r.top&&y<=r.bottom&&x>=r.left&&x<=r.right)dark=true;});
    fab.classList.toggle('on-dark',dark);}
  window.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);
  window.addEventListener('load',upd);
  upd();requestAnimationFrame(upd);[150,400,900,1800].forEach(function(t){setTimeout(upd,t)});
  if(window.ResizeObserver){try{new ResizeObserver(upd).observe(document.body)}catch(e){}}
});

/* Cards: flip + sheen + selector de modelos */
ready(function(){
  document.querySelectorAll('#productos .cardB:not(.pilot)').forEach(function(c){c.addEventListener('click',function(){c.classList.toggle('flipped')})});
  document.querySelectorAll('#productos .flipzone').forEach(function(z){z.addEventListener('click',function(){if(window.isDesktopWeb())return;z.classList.toggle('flipped')})});
  function sheenNow(){document.querySelectorAll('#productos .frontZ').forEach(function(f){f.classList.add('resheen');void f.offsetWidth;f.classList.remove('resheen')})}
  document.querySelectorAll('a[href="#productos"],.nav-cta').forEach(function(el){el.addEventListener('click',function(){setTimeout(sheenNow,450)})});
  var g=document.querySelector('#productos .grid');
  if(g){
    var cards=[].slice.call(g.querySelectorAll('.cardB'));
    var btns=[].slice.call(document.querySelectorAll('.msBtn'));
    btns.forEach(function(b,i){b.addEventListener('click',function(){var c=cards[i];if(!c)return;g.scrollTo({left:c.offsetLeft-(g.clientWidth-c.clientWidth)/2,behavior:'smooth'})})});
    g.addEventListener('scroll',function(){clearTimeout(g._t);g._t=setTimeout(function(){var mid=g.scrollLeft+g.clientWidth/2,best=0,bd=1e9;cards.forEach(function(c,i){var d=Math.abs(c.offsetLeft+c.clientWidth/2-mid);if(d<bd){bd=d;best=i}});btns.forEach(function(b,i){b.classList.toggle('active',i===best)})},80)},{passive:true});
  }
  /* botón + en cards piloto */
  document.querySelectorAll('#productos .cardB').forEach(function(card){
    var z=card.querySelector('.flipzone'), st=card.querySelector('.staticP');
    if(!z||!st) return;
    var name=st.querySelector('.nameP')||st.firstElementChild;
    var btn=document.createElement('button');btn.className='pzBtn';btn.type='button';
    btn.setAttribute('aria-label','Ver más detalles');
    var padL=parseFloat(getComputedStyle(st).paddingLeft)||26;
    btn.style.right=padL+'px';
    btn.style.top=(name.offsetTop+name.offsetHeight/2)+'px';
    btn.style.transform='translateY(-50%)';
    btn.addEventListener('click',function(e){e.stopPropagation();z.classList.toggle('flipped');btn.classList.toggle('on');});
    st.appendChild(btn);
  });
  /* barra de beneficios: duplicar en móvil para marquee */
  var b=document.querySelector('.hero-bar-inner');
  if(b&&(matchMedia('(max-width:640px)').matches||matchMedia('(max-device-width:812px)').matches)){b.innerHTML+=b.innerHTML}
  /* acordeones cerrados en móvil */
  if(matchMedia('(max-width:640px)').matches||matchMedia('(max-device-width:812px)').matches){
    document.querySelectorAll('#metodo details[open]').forEach(function(d){d.removeAttribute('open');});
  }
});
})();
